import { useMemo } from 'react';
export var useMemoObject = function useMemoObject(objectValue) {
  return useMemo(function () {
    return objectValue;
  }, Object.values(objectValue));
};